/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { SaveRequest } from "../../../../util/global_graph/global_graph";

export const protobufPackage = "skills";

export interface GlobalGraphControlActionArgs {
  save?:
    | GlobalGraphControlActionArgs_Save
    | undefined;
  /** How long to wait for the action to complete before failing. Does not apply if <= 0. */
  timeoutS: number;
}

export interface GlobalGraphControlActionArgs_Save {
  saveRequest:
    | SaveRequest
    | undefined;
  /**
   * Mark the action as succeeding when a deferred_save_queued response is received. This is not
   * valid when the save request's save type is immediate.
   */
  succeedWithDeferredSaveQueuedResponse: boolean;
}

export interface GlobalGraphControlResultData {
}

export interface GlobalGraphControlActionStateData {
}

function createBaseGlobalGraphControlActionArgs(): GlobalGraphControlActionArgs {
  return { save: undefined, timeoutS: 0 };
}

export const GlobalGraphControlActionArgs = {
  encode(message: GlobalGraphControlActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.save !== undefined) {
      GlobalGraphControlActionArgs_Save.encode(message.save, writer.uint32(10).fork()).ldelim();
    }
    if (message.timeoutS !== 0) {
      writer.uint32(21).float(message.timeoutS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalGraphControlActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalGraphControlActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.save = GlobalGraphControlActionArgs_Save.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GlobalGraphControlActionArgs {
    return {
      save: isSet(object.save) ? GlobalGraphControlActionArgs_Save.fromJSON(object.save) : undefined,
      timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : 0,
    };
  },

  toJSON(message: GlobalGraphControlActionArgs): unknown {
    const obj: any = {};
    if (message.save !== undefined) {
      obj.save = GlobalGraphControlActionArgs_Save.toJSON(message.save);
    }
    if (message.timeoutS !== 0) {
      obj.timeoutS = message.timeoutS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalGraphControlActionArgs>, I>>(base?: I): GlobalGraphControlActionArgs {
    return GlobalGraphControlActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalGraphControlActionArgs>, I>>(object: I): GlobalGraphControlActionArgs {
    const message = createBaseGlobalGraphControlActionArgs();
    message.save = (object.save !== undefined && object.save !== null)
      ? GlobalGraphControlActionArgs_Save.fromPartial(object.save)
      : undefined;
    message.timeoutS = object.timeoutS ?? 0;
    return message;
  },
};

function createBaseGlobalGraphControlActionArgs_Save(): GlobalGraphControlActionArgs_Save {
  return { saveRequest: undefined, succeedWithDeferredSaveQueuedResponse: false };
}

export const GlobalGraphControlActionArgs_Save = {
  encode(message: GlobalGraphControlActionArgs_Save, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.saveRequest !== undefined) {
      SaveRequest.encode(message.saveRequest, writer.uint32(10).fork()).ldelim();
    }
    if (message.succeedWithDeferredSaveQueuedResponse === true) {
      writer.uint32(16).bool(message.succeedWithDeferredSaveQueuedResponse);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalGraphControlActionArgs_Save {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalGraphControlActionArgs_Save();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.saveRequest = SaveRequest.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.succeedWithDeferredSaveQueuedResponse = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GlobalGraphControlActionArgs_Save {
    return {
      saveRequest: isSet(object.saveRequest) ? SaveRequest.fromJSON(object.saveRequest) : undefined,
      succeedWithDeferredSaveQueuedResponse: isSet(object.succeedWithDeferredSaveQueuedResponse)
        ? globalThis.Boolean(object.succeedWithDeferredSaveQueuedResponse)
        : false,
    };
  },

  toJSON(message: GlobalGraphControlActionArgs_Save): unknown {
    const obj: any = {};
    if (message.saveRequest !== undefined) {
      obj.saveRequest = SaveRequest.toJSON(message.saveRequest);
    }
    if (message.succeedWithDeferredSaveQueuedResponse === true) {
      obj.succeedWithDeferredSaveQueuedResponse = message.succeedWithDeferredSaveQueuedResponse;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalGraphControlActionArgs_Save>, I>>(
    base?: I,
  ): GlobalGraphControlActionArgs_Save {
    return GlobalGraphControlActionArgs_Save.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalGraphControlActionArgs_Save>, I>>(
    object: I,
  ): GlobalGraphControlActionArgs_Save {
    const message = createBaseGlobalGraphControlActionArgs_Save();
    message.saveRequest = (object.saveRequest !== undefined && object.saveRequest !== null)
      ? SaveRequest.fromPartial(object.saveRequest)
      : undefined;
    message.succeedWithDeferredSaveQueuedResponse = object.succeedWithDeferredSaveQueuedResponse ?? false;
    return message;
  },
};

function createBaseGlobalGraphControlResultData(): GlobalGraphControlResultData {
  return {};
}

export const GlobalGraphControlResultData = {
  encode(_: GlobalGraphControlResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalGraphControlResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalGraphControlResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GlobalGraphControlResultData {
    return {};
  },

  toJSON(_: GlobalGraphControlResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalGraphControlResultData>, I>>(base?: I): GlobalGraphControlResultData {
    return GlobalGraphControlResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalGraphControlResultData>, I>>(_: I): GlobalGraphControlResultData {
    const message = createBaseGlobalGraphControlResultData();
    return message;
  },
};

function createBaseGlobalGraphControlActionStateData(): GlobalGraphControlActionStateData {
  return {};
}

export const GlobalGraphControlActionStateData = {
  encode(_: GlobalGraphControlActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GlobalGraphControlActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGlobalGraphControlActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GlobalGraphControlActionStateData {
    return {};
  },

  toJSON(_: GlobalGraphControlActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GlobalGraphControlActionStateData>, I>>(
    base?: I,
  ): GlobalGraphControlActionStateData {
    return GlobalGraphControlActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GlobalGraphControlActionStateData>, I>>(
    _: I,
  ): GlobalGraphControlActionStateData {
    const message = createBaseGlobalGraphControlActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
